import { useMemo } from "react";
import { Card, Label, MonoMeta } from "@/design/primitives";
import { ProjectTile } from "./ProjectTile";

// ── EngineBay (Desk v3, Jeff 10/29: single column, accordion expand) ────────
// The capped live strip: at most WIP_CAP projects in motion, drawn as tiles.
// Clicking a tile expands it IN PLACE — no side panel. Only one tile open at
// a time; opening another closes the first.
// Jeff 2026-11-03 (desk restructure): expanded tiles carry a Park button —
// the row moves to On hold (goal row + bay twin both → TABLED).

export const WIP_CAP = 5;

const ACTIVE = ["EXECUTE", "TEST", "CLOSE"];

export const EngineBay = ({ goalCards, expandedSlug, onToggleExpand, board, projectsBoard, onFlash }) => {
  const active = useMemo(
    () => goalCards.filter((c) => ACTIVE.includes(c.rawState)),
    [goalCards],
  );
  const tiles = active.slice(0, WIP_CAP);
  const queued = Math.max(0, active.length - WIP_CAP);
  const hasLiveLanes = active.some((c) => c.rawState === "EXECUTE");
  return (
    <section data-testid="desk-engine-bay" className="flex flex-col gap-3">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div className="flex items-center gap-2">
          <Label as="h2">The engine bay</Label>
          {hasLiveLanes && (
            <span
              data-testid="desk-bay-live-dot"
              className="motion-safe:inline-block hidden h-2 w-2 rounded-full bg-os-green motion-safe:animate-pulse"
              aria-label="Live lanes running"
            />
          )}
        </div>
        <MonoMeta as="p" data-testid="engine-bay-cap">
          {tiles.length} of {WIP_CAP} slots running
          {queued > 0 ? ` · ${queued} queued below` : ""}
        </MonoMeta>
      </div>
      {tiles.length === 0 ? (
        <Card quiet className="px-5 py-4">
          <p className="text-[0.875rem] text-os-ink-2">
            Nothing is in motion this minute — the queue below feeds the bay the
            moment a project is ready to run.
          </p>
        </Card>
      ) : (
        <div className="flex flex-col gap-3">
          {tiles.map((c) => (
            <ProjectTile
              key={c.slug}
              card={c}
              expanded={expandedSlug === c.slug}
              onToggleExpand={() => onToggleExpand?.(c.slug)}
              board={board}
              projectsBoard={projectsBoard}
              onFlash={onFlash}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default EngineBay;